import createIcon from './createIcon';
import MenuUnfoldOutlinedSvg from './svg/menu-unfold-outlined.svg?react';

const MenuUnfoldOutlinedIcon = createIcon(MenuUnfoldOutlinedSvg);

export default MenuUnfoldOutlinedIcon;
